<template>
  <div>
    <div>
      <!-- <el-button type="success" size="mini" icon="el-icon-arrow-left" @click="goBack"
        style="background-color:#008A2C;float: left;">返回个人中心
      </el-button> -->
       <div   @click="goBack" style="cursor:pointer;color:#008A2C">
        <el-button type="info"  style="background-color:#008A2C;" icon="el-icon-back" circle></el-button> &nbsp;返回个人中心
     </div>
      <div class="f20 tc">
        我的消息
      </div>
    </div>
    <el-divider></el-divider>
    <div style="min-height:450px" v-if="userMsgData.length!==0"  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
    <el-row style="padding: 15px 10px 15px 20px; border-bottom: 1px dotted #ccc;cursor: pointer;" v-for="item in userMsgData"
      :key="item.id" @click.native="toMsgInfoPage(item)">
      <el-col :span="21">
        <i class="el-icon-message" style="float: left; padding: 3px 0;color: #008A2C;margin-right: 5px;"></i>
        <p>{{item.msgSource}}:{{item.msgTitle}}</p>
      </el-col>
      <el-col :span="3">
        <div class="flex-col h-center ">
          {{moment(item.createtime).format("YYYY-MM-DD HH:mm:ss")}}
        </div>
      </el-col>
    </el-row>
  </div>
  <div  style="min-height:450px;text-align:center" v-else>暂无数据</div>
    <el-pagination style="margin:20px" background layout="prev, pager, next" :total="total" :page-size="pageSize"
      :current-page="pageIndex" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { getUserMsg } from '@/api/myHome'
export default {

  name: "userMsg",
  data() {
    return {
      mylabel: '我的消息',
      activeName: "first",
      userInfo: {},
      userMsgData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      loading:true,

    };
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  mounted() {
 
    
    if(typeof(this.getUserInfo)=='object'){
       this.userInfo=this.getUserInfo
    }else{
       this.userInfo = JSON.parse(this.getUserInfo)
    }
   
    this.getUserMsg()
  },
  methods: {
    moment,
    toMsgInfoPage(msg) {
      sessionStorage.setItem("msgInfo", JSON.stringify(msg))
      this.$router.push("/userCenter/userMsgInfo?page=1");
    },
    goBack() {
      this.$router.push("/userCenter");
    },
    // 查询我的消息
    async getUserMsg() {
  
      let searchData = [
        {
          name: 'like_createuser',
          value: this.userInfo.userid
        }
      ]
      let params = {
        searchData: JSON.stringify(searchData),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sortField: 'createtime',
        sortOrder: 'desc'
      }
      const data = await getUserMsg(params)
      
      if (data.msgCode == 0) {
      
        this.userMsgData = data.data
        this.total = data.total
        this.loading=false
      }
    },
    // 分页
    handleCurrentChange(val) {
     
      this.pageIndex = val
      this.getUserMsg()
    },
  }
};
</script>
<style>

</style>